import * as React from 'react';
import Checkbox from '../../../../common/form/Checkbox';

interface Props {
    termsChecked: boolean;
    setTermsChecked: (termsChecked: boolean) => void;
    entityName: string;
    href: string;
    name: string;
}

const TermsAgreementSection = (props: Props) => (
    <div>
        <Checkbox
            inputProps={{
                checked: props.termsChecked,
                id: `${props.name}-terms-checked`,
                name: 'termsChecked'
            }}
            onChange={() => props.setTermsChecked(!props.termsChecked)}
        />
        <label htmlFor={`${props.name}-terms-checked`} className="font-weight-bold checkbox-label">
            I, and my guests, agree to {props.entityName}'s{' '}
            <a
                download={`${props.entityName} Terms of Use.pdf`}
                href={props.href}
                target="_blank"
                className="terms-and-conditions-link"
            >
                Terms of Use
            </a>
        </label>
    </div>
);

export default TermsAgreementSection;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/TermsAgreementSection.tsx